import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiUrl = 'http://localhost:7029';

  private accessToken: string = '';

  private apiAuthUrl = 'https://cesar-api.tel4b.com/v2';
  private apiAteosUrl = 'https://ateos-api.tel4b.com/v2';
  private gumUrl = 'https://gum.tel4b.com/';
  private settingsUrl = 'https://settings.tel4b.com/';
  private storageUrl = 'https://storage-api.tel4b.com/v2';

  constructor(private http: HttpClient) //eligibilityService: EligibilityService
  {}

  // Méthode pour récupérer les paramètres de l'application
  getSettingsApp(): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/domain/configuration`);
  }

  // Méthode pour récupérer le token
  getAccessToken(): string {
    return this.accessToken;
  }

  // Méthode pour définir le token
  setAccessToken(token: string): void {
    this.accessToken = token;
  }
}
